import { q } from '@actual-app/core/shared/query';
import type { CategoryEntity } from '@actual-app/core/types/models';

import { aqlQuery } from '#queries/aqlQuery';

/**
 * H67 · Categoría habitual de un beneficiario: la de su último movimiento
 * con categoría (la misma que «Sugerida» en la hoja de categoría).
 */
export async function categoriaHabitual(
  beneficiarioId: string,
): Promise<CategoryEntity['id'] | null> {
  try {
    const { data } = await aqlQuery(
      q('transactions')
        .filter({ payee: beneficiarioId, category: { $ne: null } })
        .orderBy({ date: 'desc' })
        .select(['category'])
        .limit(1),
    );
    const [fila] = data as Array<{ category: string | null }>;
    return fila?.category ?? null;
  } catch {
    return null;
  }
}
